import React from 'react'
import {
  ModalNotificationContainer,
  ModalHeadingInfo,
  ModalContentInfo,
  ButtonContainerInfo,
  NotificationButton,
  NotificationContentContainer,
} from './Styles'

interface Props {
  handleCloseModal: () => void
  headerContent: string
  bodyContent: string
  buttonContent: string
}

const ModalInfo = (props: Props) => (
  <ModalNotificationContainer onClick={(e: React.SyntheticEvent) => e.stopPropagation()}>
    <NotificationContentContainer>
      <ModalHeadingInfo>{props.headerContent}</ModalHeadingInfo>
      <ModalContentInfo>{props.bodyContent}</ModalContentInfo>
    </NotificationContentContainer>
    <ButtonContainerInfo>
      <NotificationButton onClick={props.handleCloseModal}>
        {props.buttonContent}
      </NotificationButton>
    </ButtonContainerInfo>
  </ModalNotificationContainer>
)

export default ModalInfo
